import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import { Button } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';

const HistoryAnchorComponent = ({ onClick }) => {
  const { t } = useTranslation();

  return (
    <Grid container justifyContent='flex-end'>
      <Button onClick={onClick} startIcon={<HistoryIcon />}>
        {t('Offer.Edit.Comparator.OffersHistory')}
      </Button>
    </Grid>
  );
};

HistoryAnchorComponent.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default HistoryAnchorComponent;
